import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "headbar" }
const _hoisted_2 = { class: "headbar-left" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "headbar-right" }
const _hoisted_5 = { class: "profile-menu" }
const _hoisted_6 = { class: "profile-menu-button" }
const _hoisted_7 = { class: "avatar" }
const _hoisted_8 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_data_selector = _resolveComponent("data-selector")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_dropdown = _resolveComponent("n-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        class: "brand",
        to: { name: 'dashboard', params: { group: _ctx.group?.name || 'default'}}
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: _ctx.tenantIcon,
            alt: "elichens"
          }, null, 8 /* PROPS */, _hoisted_3)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["to"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_data_selector),
        _createVNode(_component_n_dropdown, {
          trigger: "click",
          options: _ctx.options,
          onSelect: _ctx.handleSelect,
          size: "large"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_n_button, {
              size: "large",
              secondary: ""
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("img", {
                      src: _ctx.userAvatar,
                      alt: "avatar"
                    }, null, 8 /* PROPS */, _hoisted_8)
                  ])
                ])
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["options", "onSelect"])
      ])
    ])
  ]))
}